import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, TextField, Button, Typography } from "@mui/material";
import { Breadcrumb, SimpleCard } from "app/components";
import Loading from "app/components/MatxLoading";
import { GETUSER } from "app/redux/actions/users";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const ViewEmployee = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { employeeToEdit, userLoading } = useSelector((state) => state.user);
  const loggedInUser = useSelector((state) => state.user.user);

  useEffect(() => {
    if (loggedInUser?.token) {
      dispatch(
        GETUSER(id, loggedInUser, null, (error) => {
          toast.error("Failed to fetch employee details.");
          navigate(-1); 
        })
      );
    }
  }, [dispatch, id, navigate, loggedInUser]);

  if (userLoading || !employeeToEdit) {
    return <Loading />;
  }

  return (
    <SimpleCard>
      <Breadcrumb routeSegments={[{ name: "View Employee Details" }]} />
      <Box padding={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h6">Personal Information</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Name"
              value={employeeToEdit.name || "N/A"}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email"
              value={employeeToEdit.email || "N/A"}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="CNIC"
              value={employeeToEdit.cnic || "N/A"}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Phone"
              value={employeeToEdit.phone || "N/A"}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>

          <Grid item xs={12} sx={{ mt: 2 }}>
            <Typography variant="h6">Employment Details</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Joining Date"
              value={dayjs(employeeToEdit.joiningDate).format("MMMM D, YYYY")}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Device ID"
              value={employeeToEdit.deviceId || "N/A"}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Role"
              value={employeeToEdit.userType || "N/A"}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Status"
              value={employeeToEdit.status || "N/A"}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Grid>
          {employeeToEdit.deletedAt && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Deleted On"
                value={dayjs(employeeToEdit.deletedAt).format("MMMM D, YYYY")}
                InputProps={{ readOnly: true }}
                variant="filled"
              />
            </Grid>
          )}

          <Grid item xs={12} sx={{ mt: 2 }}>
            <Button variant="contained" onClick={() => navigate(-1)}>
              Back
            </Button>
          </Grid>
        </Grid>
      </Box>
    </SimpleCard>
  );
};

export default ViewEmployee;